// extracted by mini-css-extract-plugin
module.exports = {"root":"MissingImageHint_root__3b4d7","icon":"MissingImageHint_icon__1eyG9","popover":"MissingImageHint_popover__14HUc","paper":"MissingImageHint_paper__zcqhj"};